import {Injectable} from '@angular/core';
import {Question} from '../../../../../models/question.model';
import {MultiQuestions} from '../../../../../models/multi-questions';
import {AdminService} from '../../../../../services/admin.service';
import {Answer} from '../../../../../models/answer.model';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class StepTestingService {
  russianQuestions: Question[] = [];
  englishQuestions: Question[] = [];
  public questionList: any[] = [];
  public qAddedingProcess = false;

  constructor() {
  }

  deleteQuestionFromList(key) {
    if (key > -1) {
      this.questionList.splice(key, 1);
    }
  }

  addQuestionToList() {
    this.questionList.push(
      {
        questionTextRu: '',
        questionTextEn: '',
        rightAnswerRu: '',
        rightAnswerEn: '',
        answers: [
          {
            answerOneRu: '',
            answerTwoRu: '',
            answerThreeRu: '',

            answerOneEn: '',
            answerTwoEn: '',
            answerThreeEn: '',
          }
        ]
      }
    );
  }

  getQuestionList() {
    return this.questionList;
  }

  isQuestionsValid(userLanguage) {
    // *ngIf="stepsControllerService.getLocalUserLanguage() === 'En'"
    switch (userLanguage) {
      case 'Ru':
        for (const question of this.questionList) {
          if (question.questionTextRu === ''
            || (question.rightAnswerRu < 1 || question.rightAnswerRu > 3)) {
            return false;
          }
          for (const answer of question.answers) {
            if (answer.answerOneRu === ''
              || answer.answerTwoRu === ''
              || answer.answerThreeRu === '') {
              return false;
            }
          }
        }
        break;

      case 'En':
        for (const question of this.questionList) {
          if (question.questionTextEn === ''
            || (question.rightAnswerEn < 1 || question.rightAnswerEn > 3)) {
            return false;
          }
          for (const answer of question.answers) {
            if (answer.answerOneEn === ''
              || answer.answerTwoEn === ''
              || answer.answerThreeEn === '') {
              return false;
            }
          }
        }
        break;
    }

    // for (const question of this.questionList) {
    //   if (question.questionTextRu === ''
    //     || question.questionTextEn === ''
    //     || (question.rightAnswerRu < 1 || question.rightAnswerRu > 3)
    //     || (question.rightAnswerEn < 1 || question.rightAnswerEn > 3)) {
    //     return false;
    //   }
    //   for (const answer of question.answers) {
    //     if (answer.answerOneRu === ''
    //       || answer.answerTwoRu === ''
    //       || answer.answerThreeRu === ''
    //       || answer.answerOneEn === ''
    //       || answer.answerTwoEn === ''
    //       || answer.answerThreeEn === '') {
    //       return false;
    //     }
    //   }
    // }

    return true;
  }

  addQuestionToStandardTemp() {
    return this.questionList;
  }

  addQuestionsToStandard() {
    this.qAddedingProcess = true;
    for (const inputQuestion of this.questionList) {
      let answers: Answer[] = [];

      // RUS
      answers.push(
        new Answer(inputQuestion.answers[0].answerOneRu),
        new Answer(inputQuestion.answers[0].answerTwoRu),
        new Answer(inputQuestion.answers[0].answerThreeRu),
      );

      let rightAnswer: Answer;

      switch (inputQuestion.rightAnswerRu) {
        case '1' :
          rightAnswer = answers[0];
          break;
        case '2' :
          rightAnswer = answers[1];
          break;
        case '3' :
          rightAnswer = answers[2];
          break;
      }
      const russianQuestion: Question = new Question(answers, inputQuestion.checked, inputQuestion.questionTextRu, rightAnswer);

      // ENG
      answers = [];
      answers.push(
        new Answer(inputQuestion.answers[0].answerOneEn),
        new Answer(inputQuestion.answers[0].answerTwoEn),
        new Answer(inputQuestion.answers[0].answerThreeEn),
      );

      switch (inputQuestion.rightAnswerEn) {
        case '1' :
          rightAnswer = answers[0];
          break;
        case '2' :
          rightAnswer = answers[1];
          break;
        case '3' :
          rightAnswer = answers[2];
          break;
      }
      const englishQuestion: Question = new Question(answers, inputQuestion.checked, inputQuestion.questionTextEn, rightAnswer);

      // RUS + ENG
      this.russianQuestions.push(russianQuestion);
      this.englishQuestions.push(englishQuestion);
    }

    const allQuestions: MultiQuestions = new MultiQuestions(this.russianQuestions, this.englishQuestions);
    return allQuestions;
  }

  addQuestionToListCopy(i) {
    this.questionList.push(
      {
        questionTextRu: this.questionList[i].questionTextRu,
        questionTextEn: this.questionList[i].questionTextEn,
        rightAnswerRu: this.questionList[i].rightAnswerRu,
        rightAnswerEn: this.questionList[i].rightAnswerEn,
        answers: [
          {
            answerOneRu: this.questionList[i].answers[0].answerOneRu,
            answerTwoRu: this.questionList[i].answers[0].answerTwoRu,
            answerThreeRu: this.questionList[i].answers[0].answerThreeRu,

            answerOneEn: this.questionList[i].answers[0].answerOneEn,
            answerTwoEn: this.questionList[i].answers[0].answerTwoEn,
            answerThreeEn: this.questionList[i].answers[0].answerThreeEn,
          }
        ]
      }
    );
  }

  addExistingQuestuins(engQ, rusQ) {
    for (let item = 0; item < rusQ.length; item++) {
      let rightRu;
      let rightEn;

      for (let num = 0; num < 3; num++) {
        if (rusQ[item].answers[num].answerText === rusQ[item].rightAnswer.answerText) {
          rightRu = num + 1;
        }
      }

      for (let num = 0; num < 3; num++) {
        if (engQ[item].answers[num].answerText === engQ[item].rightAnswer.answerText) {
          rightEn = num + 1;
        }
      }

      this.questionList.push(
        {
          questionTextRu: rusQ[item].questionText,
          questionTextEn: engQ[item].questionText,

          rightAnswerRu: rightRu.toString(),
          rightAnswerEn: rightEn.toString(),

          answers: [
            {
              answerOneRu: rusQ[item].answers[0].answerText,
              answerTwoRu: rusQ[item].answers[1].answerText,
              answerThreeRu: rusQ[item].answers[2].answerText,

              answerOneEn: engQ[item].answers[0].answerText,
              answerTwoEn: engQ[item].answers[1].answerText,
              answerThreeEn: engQ[item].answers[2].answerText,
            }
          ]
        }
      );

    }
  }

  clearQuestions() {
    this.questionList = [];
    this.russianQuestions = [];
    this.englishQuestions = [];
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-six/step-cteate-testing/step-testing.service.ts